<template>
  <b-modal
    ref="my-modal"
    :id="idModal"
    size="md"
    centered
    :hide-header="true"
    :hide-footer="true"
    content-class="p-2 atm-rounded"
    no-close-on-backdrop
  >
    <div class="d-flex flex-column align-items-center position-relative">
      <p class="position-relative h3 text-uppercase font-weight-bold">
        Congrats!!!
      </p>
      <p class="position-relative h4 mb-5">You just earned</p>
      <div
        class="position-relative gap-2 d-flex flex-column align-items-center mb-5 w-100"
      >
        <div
          class="coins-container position-relative d-flex justify-content-center"
        >
          <div class="background-image position-absolute">
            <img :src="require('@/assets/bg-congrats.png')" />
          </div>

          <div class="position-relative">
            <div
              class="image-container position-relative d-flex justify-content-center align-items-center"
            >
              <img :src="require('@/assets/coin2.png')" alt="" />
              <label
                class="coins-value position-absolute font-weight-bolder m-0"
              >
                {{ coins }}
              </label>
            </div>
            <label
              class="points position-absolute text-white rounded-pill py-1 px-3 atm-shadow"
            >
              {{ points }} pts
            </label>
          </div>
        </div>
        <p class="text-center h4 mt-3">
          {{ description }}
        </p>
        <p class="h4 font-weight-bolder">Keep it up!</p>
      </div>
      <div class="position-relative d-flex flex-column">
        <small class="mb-3 font-weight-600" v-if="!getSelfManagementIsActive">
          Remember that {{ getParentName }} must confirm to get these points.
        </small>
        <button
          @click="hideUpdateRewardModal"
          class="atm-button bg-main mx-auto w-75 text-uppercase"
        >
          Ok
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { useSessionStore } from '@/common';
export default {
  props: {
    coins: {
      type: [String, Number],
      default: 0
    },
    points: {
      type: [String, Number],
      default: 0
    },
    description: {
      type: String,
      default: ''
    },
    idModal: {
      type: String,
      default: 'congrats-modal'
    }
  },
  data(){
    const sessionStore = useSessionStore()
    return {
      sessionStore
    }
  },
  computed: {
    ...mapGetters('module', ['getSelfManagementIsActive']),
    getParentName(){
      return this.sessionStore.parentName
    }
  },
  methods: {
    hideUpdateRewardModal() {
      this.$emit('onClose', true);
      this.$bvModal.hide(this.idModal);
    }
  },
};
</script>

<style lang="scss">
.modal-body {
  &.congrats {
    padding: 0;
  }
}

.coins-container {
  width: 100%;
  & .image-container {
    width: 150px;
    height: 150px;
    & > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    & .coins-value {
      font-size: 3rem;
      width: min-content;
      height: min-content;
      top: 17.5%;
    }
  }

  .points {
    bottom: 10%;
    right: 0;
    background-color: #a9e27a;
  }
}

.background-image {
  width: 100%;
  height: 100%;
  & > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
